const initialState = {
  isFetching: false,
  isFetched: false,
  success: false,
  error: false,
  data: null,
  origin: [],
  destination: [],
  selectedDest: { value: '', uriTerm: '' },
  selectedOrigin: '',
  noAccount: false
}

export const ACTION_TYPES = {
  FINANCIAL_TRANSFER_ACCOUNTS_REQUEST: 'FINANCIAL_TRANSFER_ACCOUNTS_REQUEST',
  FINANCIAL_TRANSFER_ACCOUNTS_SUCCESS: 'FINANCIAL_TRANSFER_ACCOUNTS_SUCCESS',
  FINANCIAL_TRANSFER_ACCOUNTS_ERROR: 'FINANCIAL_TRANSFER_ACCOUNTS_ERROR',
  FINANCIAL_TRANSFER_ACCOUNTS_SELECT_ITEM: 'FINANCIAL_TRANSFER_ACCOUNTS_SELECT_ITEM',
  FINANCIAL_TRANSFER_ACCOUNTS_SELECT_ITEM_DEST: 'FINANCIAL_TRANSFER_ACCOUNTS_SELECT_ITEM_DEST',
  FINANCIAL_TRANSFER_ACCOUNTS_CLEAR: 'FINANCIAL_TRANSFER_ACCOUNTS_CLEAR'
}

const getAccountsSuccess = (state, { data }) => {
  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    success: true,
    data
  }

  newState.origin = data.origin.map(item => ({
    key: item.account.type,
    value: item.account.description,
    accountNumber: item.account.accountNumber,
    availableWithdrawMoney: item.availableWithdrawMoney
  }))

  // Em breve essa alternativa para tratar no Front será removida
  newState.origin.splice(newState.origin.findIndex(e => e.key === 1), 1)

  return newState
}

const getItemSelection = (state, payload) => {
  const newState = { ...state }

  newState.noAccount = false
  newState.selectedOrigin = payload.value

  // Em breve essa alternativa para tratar no Front será removida
  const destination = newState.data.destination.filter(({ type }) => {
    if (type === 1) return true
    return false
  })

  newState.destination = destination.reduce((memo, item) => {
    if (payload.key !== item.type) {
      memo.push({ key: item.type, value: item.description, uriTerm: item.uriTerm })
    }

    return memo
  }, [])

  return newState
}

const getItemSelectionDest = (state, payload) => {
  const newState = { ...state }

  const tempList = newState.origin.map(item => item.value)
  if (!tempList.includes(payload.value)) {
    newState.noAccount = true
  } else {
    newState.noAccount = false
  }

  newState.selectedDest = payload

  return newState
}

export const getAccounts = () => ({
  type: ACTION_TYPES.FINANCIAL_TRANSFER_ACCOUNTS_REQUEST
})

export const selectItem = payload => ({
  type: ACTION_TYPES.FINANCIAL_TRANSFER_ACCOUNTS_SELECT_ITEM,
  payload
})

export const selectItemDest = payload => ({
  type: ACTION_TYPES.FINANCIAL_TRANSFER_ACCOUNTS_SELECT_ITEM_DEST,
  payload
})

export const clear = () => ({
  type: ACTION_TYPES.FINANCIAL_TRANSFER_ACCOUNTS_CLEAR
})

const financialTransferAccounts = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.FINANCIAL_TRANSFER_ACCOUNTS_REQUEST:
      return {
        ...initialState,
        isFetching: true
      }
    case ACTION_TYPES.FINANCIAL_TRANSFER_ACCOUNTS_SUCCESS:
      return getAccountsSuccess(state, action.payload)
    case ACTION_TYPES.FINANCIAL_TRANSFER_ACCOUNTS_ERROR:
      return {
        ...initialState,
        isFetched: true,
        error: true,
        data: action.payload
      }
    case ACTION_TYPES.FINANCIAL_TRANSFER_ACCOUNTS_SELECT_ITEM:
      return getItemSelection(state, action.payload)
    case ACTION_TYPES.FINANCIAL_TRANSFER_ACCOUNTS_SELECT_ITEM_DEST:
      return getItemSelectionDest(state, action.payload)
    case ACTION_TYPES.FINANCIAL_TRANSFER_ACCOUNTS_CLEAR:
      return {
        ...state,
        noAccount: false,
        destination: []
      }
    default:
      return state
  }
}

export default financialTransferAccounts
